import {Attachments} from './alert.model';
import {Utilities} from '@shared/utilities/utilities.model';
import {AttachedFile} from '@shared/models/attached-file.model';
import {DateUtilities} from '@shared/utilities/date-utilities.model';
import {NotificationCenterUtilities} from '../utilities/notification-center.utilities';

/**
 * Created by wladimir on 15/06/18.
 */

/**
 * this class is used for => create new alert (new thread)
 */

export class NCNewAlert {
	alert_id: string;
	created_by: string;
	user_id: string;
	readers: string[];
	module: string;
	commodity_id: any;
	ald_commodity_id: string;
	ald_order_id: any;
	subject: string;
	text: string;
	flags?: string[];
	attachments: Attachments[];
	metadata: Map<string, string>;
	private check_id?: number;

	constructor(model?: any) {
		this.attachments = [];
		this.readers = [];
		this.metadata = new Map<string, string>();
	}

	getBody(): any {

		const obj: any = {};
		this.metadata.forEach((value, key) => {
			const keys: string[] = key.split('.'),
				last: string = keys.pop();
			keys.reduce((r, a) => r[a] = r[a] || {}, obj)[last] = value;
		});

		const newAlert: any = {
			alert_id: this.alert_id,
			created_by: this.created_by,
			user_id: this.user_id,
			readers: this.readers,
			module: this.module,
			commodity_id: this.commodity_id,
			ald_commodity_id: this.ald_commodity_id,
			ald_order_id: this.ald_order_id,
			subject: this.subject,
			text: this.text,
			attachments: this.attachments,
			metadata: obj
		};
		return newAlert;
	}

	setCheckId(check_id: number): void {
		this.check_id = check_id;
	}

	getCheckId(): number {
		return this.check_id;
	}

	settingByForm(model: any): void {
		if (!Utilities.isVoid(model)) {
			this.ald_order_id = model.ald_order_id;
			this.module = model.module;
			this.subject = model.subject;
			this.text = model.text;
			this.readers = model.readers;
			if (!Utilities.isVoid(model.plate)) {
				this.metadata.set(NotificationCenterUtilities.METADATA_PLATE, model.plate);
			}
			if (!Utilities.isVoid(model.chassis)) {
				this.metadata.set(NotificationCenterUtilities.METADATA_CHASSIS, model.chassis);
			}
			if (!Utilities.isVoid(model.txt_category)) {
				this.metadata.set(NotificationCenterUtilities.METADATA_CATEGORY, model.txt_category);
			}
			if (!Utilities.isVoid(model.txt_context)) {
				this.metadata.set(NotificationCenterUtilities.METADATA_CONTEXT, model.txt_context);
			}
			if (!Utilities.isVoid(model.txt_detail)) {
				this.metadata.set(NotificationCenterUtilities.METADATA_DETAIL, model.txt_detail);
			}
		}
	}

	addAttached(attached: AttachedFile): void {
		this.attachments.push({
			file_manager_id: attached.uuid,
			file_manager_name: attached.file_name,
			blob_name: attached.blob_name,
			blob_size: attached.file_size,
			mime_type: attached.mime_type,
			description: attached.description,
			created_at: DateUtilities.getUTCStringFromDate(new Date())
		});
	}
}
